<script>
import _ from "lodash";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import constants from "../../constants";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Progressive Marks",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Progressive Marks",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Progressive Marks",
          active: true,
        },
      ],
      data: {
        year: "",
        term: "",
        class: "",
        stream: "",
        // set this parameter to retrieve comments since they use the same endpoint with reports page view
        comments: true,
      },
      currentDate: new Date().toISOString().slice(0, 10),
      sysConstants: constants,
    };
  },
  computed: {
    ...mapGetters("coursework", ["AllSets"]),
    ...mapGetters("classes", ["AllClasses", "AllClassStreams"]),
    ...mapGetters("marks", [
      "SaveStatus",
      "getYears",
      "getProgressMarks",
      "getFechingReports",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchYears: "marks/fetchYear",
      FetchClasses: "classes/fetchClasses",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchSets: "coursework/fetchSets",
      FetchStreams: "classes/fetchStreams",
      FetchProgressiveMarks: "marks/fetchProgressiveMarks",
      UpdateProgressiveMarks: "marks/updateProgressiveMarks",
    }),
    updateMarks($event, initData, enrolId, subjectId, criteriaId) {
      const newMarks = $event.target.value;
      // to prevent state mutation.
      const progData = _.cloneDeep(initData);
      newMarks != ""
        ? this.UpdateProgressiveMarks({
            newMarks,
            progData,
            enrolId,
            subjectId,
            criteriaId,
          })
        : null;
    },
    submitFilter() {
      this.FetchProgressiveMarks(this.data);
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    fetchStreamsinClass(event) {
      const id = event.target.value;
      const classSelected = { id };
      //fetching class streams
      this.FetchClassStreams(classSelected);
    },
    resetAddModal() {
      this.data.name = "";
      this.resetError();
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchStreams();
    this.FetchSets();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_report_comments')
        )
      "
    >
      <div class="col-12">
        <b-card no-body class="mb-1 shadow-none">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a
                v-b-toggle.accordion-1
                class="text-primary"
                href="javascript: void(0);"
                ><u> Click to Filter Students</u>
                <i class="fa fa-filter" aria-hidden="true"></i
              ></a>
            </h6>
          </b-card-header>
          <b-collapse
            id="accordion-1"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <form @submit.prevent="submitFilter()">
                <div class="row">
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for="">Year</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="data.year"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Year</option>
                        <option
                          v-for="(schyear, i) in getYears"
                          :value="schyear.year"
                          :key="i"
                        >
                          {{ schyear.year }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for="">Term</label>
                      <select
                        required
                        class="form-control form-control-sm"
                        v-model="data.term"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Term</option>
                        <option value="1">Term 1</option>
                        <option value="2">Term 2</option>
                        <option value="3">Term 3</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for="">Class</label>
                      <select
                        required
                        class="form-control form-control-sm"
                        v-model="data.class"
                        @change="fetchStreamsinClass($event)"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Class</option>
                        <option
                          v-for="(classes, index) in AllClasses"
                          :key="index"
                          :value="classes.id"
                        >
                          {{ classes.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for="">Stream </label>
                      <select
                        class="form-control form-control-sm"
                        v-model="data.stream"
                        name=""
                        id=""
                        required
                      >
                        <option value="" selected disabled>
                          Select Stream
                        </option>
                        <option
                          v-for="(stream, index) in AllClassStreams"
                          :value="stream.id"
                          :key="index"
                        >
                          {{ stream.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3 mt-3">
                    <button
                      type="submit"
                      size="sm"
                      disabled
                      class="btn btn-sm btn-outline-primary mt-2"
                      v-if="getFechingReports"
                    >
                      <b-spinner
                        variant="primary"
                        small
                        label="Fetching Data..."
                      ></b-spinner>
                      Fetching Data...
                    </button>
                    <button
                      v-else
                      type="submit"
                      size="sm"
                      class="btn btn-sm btn-outline-primary mt-2"
                    >
                      <i class="fa fa-check"></i>
                      Submit Filers
                    </button>
                  </div>
                </div>
              </form>
              <div
                class="alert alert-secondary text-center col-md-8 mt-3"
                v-if="getProgressMarks"
              >
                <span>
                  <strong class="text-primary"
                    >{{ getProgressMarks.marks.length }}
                  </strong>
                  Students found.
                </span>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <div class="col-12">
        <div class="col-lg-12" v-if="getProgressMarks">
          <b-card
            class="mb-2"
            no-body
            v-for="(marksDetails, index) in getProgressMarks.marks"
            :key="index"
          >
            <b-row no-gutters class="mx-4 align-items-center">
              <b-col md="12">
                <b-card-body>
                  <h4
                    class="
                      card-title
                      text-uppercase
                      font-weight-bold
                      text-primary
                    "
                  >
                    {{ marksDetails.student.name }}
                  </h4>
                  <h6>
                    <strong>
                      Term:
                      <span class="text-muted">
                        {{ getProgressMarks.term }}</span
                      >
                      | Class:
                      <span class="text-success">
                        {{ marksDetails.classx.name }}
                      </span>
                      | Stream:
                      <span class="text-muted">
                        {{ marksDetails.streamx.name }}</span
                      >
                    </strong>
                  </h6>
                </b-card-body>
                <hr />
              </b-col>
            </b-row>
            <b-row no-gutters class="mx-4 align-items-center">
              <b-col
                md="6"
                v-for="(subject, sub_index) in marksDetails.classx.subjects"
                :key="sub_index"
              >
                <b-card-body>
                  <h4 class="card-title mb-4">{{ subject.name }}</h4>
                  <div v-if="subject.criteria.length != 0">
                    <div
                      class="form-group mt-3"
                      v-for="(crt, crt_index) in subject.criteria"
                      :key="crt_index"
                    >
                      <label for="">{{ crt.criteria }}</label>
                      <textarea
                        @blur="
                          updateMarks(
                            $event,
                            getProgressMarks,
                            marksDetails.id,
                            subject.id,
                            crt.id
                          )
                        "
                        :placeholder="
                          crt.marks
                            ? crt.marks
                            : 'Please Enter Your Comment or Mark'
                        "
                        class="form-control form-control-sm"
                        name=""
                        id=""
                        cols="10"
                        rows="2"
                      ></textarea>
                    </div>
                  </div>
                  <div class="alert alert-secondary" role="alert" v-else>
                    <span>No Criteria set for this section.</span>
                  </div>
                </b-card-body>
              </b-col>
            </b-row>
            <b-row no-gutters class="mx-4 align-items-center">
              <b-col md="12">
                <hr />
                <b-card-body>
                  <h4 class="card-title mb-4">
                    Overall Comments (Class Teacher and Head Teacher)
                  </h4>
                  <div class="row">
                    <div class="form-group mt-3 col-md-6">
                      <label for="">Class Teacher's Comment</label>
                      <textarea
                        @blur="
                          updateMarks(
                            $event,
                            getProgressMarks,
                            marksDetails.id,
                            '',
                            'tr'
                          )
                        "
                        :placeholder="
                          marksDetails.teacher_cm
                            ? marksDetails.teacher_cm
                            : 'Please Enter An Overall Comment As Class Teacher'
                        "
                        class="form-control form-control-sm"
                        name=""
                        id=""
                        cols="10"
                        rows="2"
                      ></textarea>
                    </div>
                    <div class="form-group mt-3 col-md-6">
                      <label for="">Head Teacher's Comment</label>
                      <textarea
                        @blur="
                          updateMarks(
                            $event,
                            getProgressMarks,
                            marksDetails.id,
                            '',
                            'hm'
                          )
                        "
                        :placeholder="
                          marksDetails.hm_cm
                            ? marksDetails.hm_cm
                            : 'Please Enter An Overall Comment As Head Teacher'
                        "
                        class="form-control form-control-sm"
                        name=""
                        id=""
                        cols="10"
                        rows="2"
                      ></textarea>
                    </div>
                  </div>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <div class="col-lg-12" v-else>
          <b-card class="mb-2" :key="index">
            <b-row no-gutters class="align-items-center">
              <b-card-body>
                <div class="alert alert-primary text-center" role="alert">
                  <span>Please use the filter to select the students</span>
                </div>
              </b-card-body>
            </b-row>
          </b-card>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
